import { Injectable } from '@angular/core';
import { VehicleTypeEnum } from '../models/vehicle-type';

@Injectable()
export class VehicleTypeService {

  vehicleTypes = new Map<number, string>();

  constructor() {
    this.vehicleTypes.set(1, $localize`:@@vehicle.type.big-bus:Stor buss`);
    this.vehicleTypes.set(2, $localize`:@@vehicle.type.small-bus:Liten buss`);
    this.vehicleTypes.set(3, $localize`:@@vehicle.type.double-decker:Dubbeldäckare`);
    this.vehicleTypes.set(4, $localize`:@@vehicle.type.taxi:Taxi`);
    this.vehicleTypes.set(5, $localize`:@@vehicle.type.big-taxi:Stor taxi`);
    this.vehicleTypes.set(6, $localize`:@@vehicle.type.wheelchair-taxi:Rullstolstaxi`);
    this.vehicleTypes.set(7, $localize`:@@vehicle.type.standby-bus:Stand-by buss`);
    this.vehicleTypes.set(8, $localize`:@@vehicle.type.standby-wheelchair-taxi:Stand-by rullstolstaxi`);
    this.vehicleTypes.set(9, $localize`:@@vehicle.type.customer-host:Kundvärd`);
    this.vehicleTypes.set(10, $localize`:@@vehicle.type.bus-coordinator:Busskoordinator`);
    this.vehicleTypes.set(11, $localize`:@@vehicle.type.standby-taxi:Stand-by taxi`);
  }

  getVehicleType(vehicleTypeEnum: number): string {
    return this.vehicleTypes.get(vehicleTypeEnum);
  }

  getVehicleTypeByString(vehicleType: string | undefined): string {
    switch (vehicleType) {
      case 'BigBus':
        return $localize`:@@vehicle.type.big-bus:Stor buss`;
      case 'SmallBus':
        return $localize`:@@vehicle.type.small-bus:Liten buss`;
      case 'DoubleDecker':
        return $localize`:@@vehicle.type.double-decker:Dubbeldäckare`;
      case 'Taxi':
        return $localize`:@@vehicle.type.taxi:Taxi`;
      case 'BigTaxi':
        return $localize`:@@vehicle.type.big-taxi:Stor taxi`;
      case 'WheelchairTaxi':
        return $localize`:@@vehicle.type.wheelchair-taxi:Rullstolstaxi`;
      case 'StandbyBus':
        return $localize`:@@vehicle.type.standby-bus:Stand-by buss`;
      case 'StandbyWheelchairTaxi':
        return $localize`:@@vehicle.type.standby-wheelchair-taxi:Stand-by rullstolstaxi`;
      case 'CustomerHost':
        return $localize`:@@vehicle.type.customer-host:Kundvärd`;
      case 'BusCoordinator':
        return $localize`:@@vehicle.type.bus-coordinator:Busskoordinator`;
      case 'StandbyTaxi':
        return $localize`:@@vehicle.type.standby-taxi:Stand-by taxi`;
      default:
        return '';
    }
  }

  getAllVehicleTypeDescriptions(): string[] {
    return Array.from(this.vehicleTypes.values());
  }

  getEnumValueByDescription(description: string): number {
    for (const [key, value] of this.vehicleTypes) {
      if (value === description) {
        return key;
      }
    }
    return null;
  }
}